<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();
</script>

<svg class="icon" on:click={() => dispatch("click")} width="31" height="18" viewBox="0 0 21 18" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M-6.99382e-07 9L20 9M20 9L11.6667 17M20 9L11.6667 1" stroke="#1A1A17"/>
</svg>

